import { SystemStyleObject } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'

/**
 * Field-label styling shared by the dark form controls (TextInput, Select).
 * Matches the Figma "Label" text style via the theme `label` textStyle, keyed
 * to the mode-aware primary text colour. Kept in one place so label token/text
 * changes only need editing here.
 */
export const fieldLabelStyles = (
  colorScheme: ColorScheme
): SystemStyleObject => ({
  color: colorScheme === 'light' ? 'light.text.primary' : 'text.primary',
  pb: '4px',
  textStyle: 'label',
})

/**
 * Stacks a field label above its control. Pass `width` to constrain the group
 * to the control's width (e.g. TextInput); omit it for full-width controls
 * (e.g. Select).
 */
export const fieldLabelWrapperStyles = (
  width?: string | number
): SystemStyleObject => ({
  display: 'flex',
  flexDirection: 'column',
  ...(width !== undefined ? { width } : {}),
})
